<template>
    <div :class="['totem-certification-badge', size]" v-html="name"></div>
</template>

<script>
    export default {
        props: {
            name: String,
            size: {
                type: String,
                validator: (prop) => ['small', 'medium'].includes(prop),
                default: 'medium'
            }
        }
    }
</script>

<style lang="scss">
    .totem-certification-badge {
        background: $rust-orange;
        color: $white;
        margin: 0 5px 2px 0;
        text-transform: uppercase;
        width: auto;
        padding: 0 10px;
        cursor: pointer;
        font-family: 'Quicksand-Regular';
        white-space: break-spaces;
        display: inline-block;

        &.small {
            font-size: 1.25rem;
            line-height: 17px;
        }

        &.medium {
            font-size: 1.4rem;
            line-height: 24px;
        }
    }
</style>
